module.exports = __webpack_public_path__ + "img/web_link.c0e551be.svg";